// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__2sWPB","itemTitle":"ClientEmergencyInfo_itemTitle__25hGG","itemText":"ClientEmergencyInfo_itemText__89PtM"};